export default {
  content: 'contenu',
  labels: {
    actions: 'Actions',
    principles: 'Principes',
  },
  legends: {
    personas: 'Légende personas',
    principles: 'Liste des principes',
  },
  partners:
    'Nous remercions nos partenaires pour leur précieuse collaboration : l’Observatoire international sur les impacts sociétaux de l’IA et du numérique (OBVIA), l’Institut de recherche en IA (MILA), la Gestion du réseau informatique des commissions scolaires (GRICS), pour leur contribution à la création de cet outil.',
  skip_to_content: 'Passer au contenu',
  title: "Phases de l'encadrement éthique d'un système d'IA",
}
